<template>
  <v-card>
    <v-card-title :class="color" class="pb-1 pt-1 mt-2">
      {{ title }}
      <v-btn v-if="permissions['9'] && permissions['8']" class="ml-auto" small @click="addItem" :color="color"
        >add item</v-btn
      >
    </v-card-title>
    <v-card-text class="py-0">
      <v-timeline dense>
        <template v-for="(item, index) in dataList">
          <v-timeline-item
          class="pb-3"
          :key="index"
          :color="item.type === 0 ? 'red' : item.type === 1 ? 'blue' : item.type === 2 ? 'green' : color"
          right
          small
          v-if="item.status === 1"
        >
          <editor
            :data-item="item"
            :color="color"
            :key-value="keyValue"
            :save-marker="saveMarker"
            @remove-item="removeItem(index)"
          />
        </v-timeline-item>
        </template>

      </v-timeline>
    </v-card-text>
  </v-card>
</template>
<script>
import Editor from "./editor/editor.component";
export default {
	components: {
		Editor,
	},
	props: {
		dataList: Array,
		title: String,
		color: String,
		keyValue: String,
		saveMarker: Boolean
	},
	computed: {
		permissions() {
			return this.$store.getters.permissions;
		},
	},
	methods: {
		addItem() {
			const item = Object.assign({}, this.dataList[0]);
			for (const key in item) {
				item[key] = null;
			}
			item.status = 1;
			this.dataList.push(item);
		},
		removeItem(index) {
			if (this.dataList[index].system_id || this.dataList[index].trailer_type_id) this.dataList[index].status = 0;
			else this.dataList.splice(index, 1);
		},
	},
};
</script>
<style lang="scss" scoped>
@import "./dynamic-list.component";
</style>
